'use client';
import React from 'react';
import { Icon, Button } from '@benzinga/core-ui';
import { AddToWatchlist } from '@benzinga/watchlist-ui';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons/faStar';

interface WatchlistTableButtonProps {
  isActive: boolean;
  symbol: string;
}

export const WatchlistTableButton: React.FC<WatchlistTableButtonProps> = ({ isActive, symbol }) => {
  return (
    <>
      {!isActive ? (
        <>
          <AddToWatchlist
            buttonText={'Add to Watchlist'}
            buttonVariant={'flat-blue'}
            showIcon={true}
            symbol={symbol}
            variant="default"
          />
        </>
      ) : (
        <Button aria-label="Add to watchlist" size={'md'} variant={'flat-blue'}>
          <Icon className="mr-1" icon={faStarRegular} />
          Add To Watchlist
        </Button>
      )}
    </>
  );
};
